// src/components/layout/Layout.jsx
import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { Navbar } from '@/components/layout/Navbar';
import { Sidebar } from '@/components/layout/Sidebar';

export function Layout({ children }) {
  useDocumentTitle();

  return (
    <div className="sl-layout min-h-screen bg-background-dim">
      <Navbar />
      <Sidebar />
      <main className="sl-main-content pl-64 pt-16">
        <div className="sl-page-container mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
          {children}
        </div>
      </main>
    </div>
  );
}
